import { useMutation } from '@tanstack/react-query';

import { getProfile } from '@services/profile/profile.service';

export function useSearchProfile(accessToken: string) {
  return useMutation({
    mutationFn: (cpf: string) => getProfile(cpf, accessToken),
  });
}
